<script setup lang="ts">
import { FormKitLazyProvider } from '@formkit/vue'
// Overrides @basecom-gmbh/pond/components/product/ProductAddToWishlist.vue
// IDS-19: change padding from icon, change icon
import type { Schemas } from '@shopware/api-client/api-types';

const props = withDefaults(
    defineProps<{
        product: Schemas['Product'];
        layout?: 'standard' | 'minimal' | 'text';
    }>(),
    {
        layout: 'standard',
    },
);

const { isInWishlist, addToWishlist, removeFromWishlist } = useProductWishlist(props.product.id);
//const { trackAddToWishlist, trackRemoveFromWishlist } = useAnalytics();
const { pushSuccess, pushError } = useNotifications();
const { t } = useI18n();

const handleWishlistButtonClicked = async () => {
    if (isInWishlist.value) {
        try {
            await removeFromWishlist();
            // TODO: Add tracking when GA is added
            //trackRemoveFromWishlist(props.product);
            pushSuccess(t('wishlist.removedSuccessfully'));
        } catch (error) {
            pushError(t('wishlist.errorRemovingProduct'));
        }
    } else {
        try {
            await addToWishlist();
            //trackAddToWishlist(props.product);
            pushSuccess(t('wishlist.addedSuccessfully'));
        } catch (error) {
            pushError(t('wishlist.errorAddingProduct'));
        }
    }
};
</script>

<template>
    <div
        class="cursor-pointer select-none p-5"
        :class="{ 'flex place-items-center gap-2 !p-0': layout === 'text' }"
        @click="handleWishlistButtonClicked"
    >
        
<FormKitLazyProvider config-file="true">
<FormKitIcon
            class="wishlist-icon block size-6 text-neutral-500"
            :class="{
                '*:fill-none': !isInWishlist,
            }"
            icon="heart"
        />
        <div
            v-if="layout === 'text'"
            class="text-sm"
        >
            {{ isInWishlist ? t('wishlist.removeFromWishlist') : t('wishlist.addToWishlist') }}
        </div>
</FormKitLazyProvider>

    </div>
</template>

<style>
.wishlist-icon path {
    @apply stroke-neutral-500;
}
</style>
